var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#01313D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1412 26.5043C16.9857 26.5043 16.8399 26.4798 16.7037 26.4308C16.5676 26.3826 16.4412 26.3001 16.3246 26.1835L11.3079 21.1668C11.094 20.9529 10.9917 20.6756 11.0011 20.335C11.0112 19.9951 11.1232 19.7182 11.3371 19.5043C11.551 19.2904 11.8232 19.1835 12.1537 19.1835C12.4843 19.1835 12.7565 19.2904 12.9704 19.5043L17.1412 23.6751L27.0287 13.7876C27.2426 13.5737 27.5199 13.4668 27.8606 13.4668C28.2005 13.4668 28.4774 13.5737 28.6912 13.7876C28.9051 14.0015 29.0121 14.2784 29.0121 14.6183C29.0121 14.959 28.9051 15.2362 28.6912 15.4501L17.9579 26.1835C17.8412 26.3001 17.7149 26.3826 17.5787 26.4308C17.4426 26.4798 17.2968 26.5043 17.1412 26.5043Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleBlue);
export default __webpack_public_path__ + "static/media/check-circle-blue.43fc32b766aa7da08c4bc27814a21d46.svg";
export { ForwardRef as ReactComponent };